import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Space, Table, Tag, Input } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useLeave } from '../../hooks/useLeave';

const { TextArea } = Input;

const MANAGER_ID = 1; // TODO: inject from auth context

const LeaveApprovalView: React.FC = () => {
  const [rejectModal, setRejectModal] = useState<{ open: boolean; id: number | null }>({ open: false, id: null });
  const [rejectReason, setRejectReason] = useState('');
  const { leaveRequests, isLoading, fetchLeaveRequests, approveLeaveRequest, rejectLeaveRequest } = useLeave();

  useEffect(() => { fetchLeaveRequests(0, 'PENDING'); }, []);

  const handleApprove = (id: number) => approveLeaveRequest(id, MANAGER_ID);
  const handleReject = async () => {
    if (rejectModal.id) {
      await rejectLeaveRequest(rejectModal.id, MANAGER_ID, rejectReason);
      setRejectModal({ open: false, id: null });
      setRejectReason('');
    }
  };

  const columns = [
    { title: 'Employee', dataIndex: 'employeeName', key: 'employeeName' },
    { title: 'Emp No.', dataIndex: 'employeeNumber', key: 'employeeNumber', width: 100 },
    { title: 'Leave Type', dataIndex: 'leaveTypeName', key: 'leaveTypeName' },
    { title: 'From', dataIndex: 'startDate', key: 'startDate', width: 100 },
    { title: 'To', dataIndex: 'endDate', key: 'endDate', width: 100 },
    { title: 'Days', dataIndex: 'daysRequested', key: 'daysRequested', width: 60 },
    { title: 'Reason', dataIndex: 'reason', key: 'reason', ellipsis: true },
    {
      title: 'Status', dataIndex: 'status', key: 'status', width: 100,
      render: (s: string) => <Tag color="orange">{s}</Tag>,
    },
    {
      title: 'Actions', key: 'actions', width: 140,
      render: (_: any, record: any) => (
        <Space size="small">
          <Button
            type="primary" size="small" icon={<CheckOutlined />}
            onClick={() => handleApprove(record.id)}
          >Approve</Button>
          <Button
            danger size="small" icon={<CloseOutlined />}
            onClick={() => setRejectModal({ open: true, id: record.id })}
          >Reject</Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="p-6">
      <Card title="Pending Leave Approvals">
        <Table dataSource={leaveRequests} columns={columns} rowKey="id" loading={isLoading} size="small" />
      </Card>

      <Modal
        title="Reject Leave Request"
        open={rejectModal.open}
        onOk={handleReject}
        onCancel={() => setRejectModal({ open: false, id: null })}
        okText="Reject"
        okButtonProps={{ danger: true }}
      >
        <TextArea
          rows={3}
          placeholder="Provide reason for rejection..."
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default LeaveApprovalView;
